<div class="grey-box">
  <h3>{{title}}</h3>
  <div class="grey-box-content" [innerHTML]="content"></div>

  @if (pageContent.PageSubContents.length > 0) {
    <div class="sub-section">
      <app-page-content-loop [pageContents]="pageContent.PageSubContents"></app-page-content-loop>
    </div>
  }
</div>